export default {
    getChatData: ({chatData}) => chatData,

    getMessages: ({messages}) => messages,
    getTaggingMessage: ({taggingMessage}) => taggingMessage,
    getUnBlurredMessage: ({unBlurredMessage}) => unBlurredMessage,
    getComments: ({comments}) => comments,

    isTagging: ({isTagging}) => isTagging,
    getLoadingState: ({isLoading}) => isLoading,
    getHasMoreMessages: ({hasMoreMessages}) => hasMoreMessages,

    getChatTags: ({chatTags}) => chatTags,
    getMessageTags: ({messageTags}) => messageTags,
    getTagsList: ({tagsList}) => tagsList,

    getCountReminders: ({countReminders}) => countReminders,
    getReminderMessages: ({reminderMessages}) => reminderMessages,

    // getters for reactive active message management
    getActiveMessageId: ({chatData}) => chatData.searchMessageId || chatData.taggingMessageId,
    getSearchMessageId: ({chatData}) => chatData.searchMessageId,
    getTaggingMessageId: ({chatData}) => chatData.taggingMessageId,
};
